import $ from 'jquery'

import './partials/cookies.js'
import './partials/faq.js'
import './partials/forms.js'
import './partials/header.js'
import './partials/other-links'
import './partials/product-selection'
import './partials/phone-fields'
import './partials/post-gallery-slider'
import './partials/post-navigation'
import './partials/products'
import './partials/search'
import './partials/sequences'
import './partials/question-form'
import './partials/youtube-video'
// sliders 
import './partials/sliders/buttons-carousel'
import './partials/sliders/horizontal-post-slider'
import './partials/sliders/posts-slider'
import './partials/sliders/testimonials-slider'
import './partials/sliders/youtube-slider'
//import './partials/sliders/video-slider'
import loadSvg from './utils/svg'

document.addEventListener("touchstart", function(){}, true);

(function( $ ) { 
  
    $('img.svg').each(function() {
        loadSvg(this);
    });

    $('.wp-block-image').each(function(){
        if($(this).find('figcaption').length > 0) {
            $(this).addClass('has-figcaption');
        }
    })

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/app.js